
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/articles",
      function () {
        return require("private-next-pages/[locale]/articles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/articles"])
      });
    }
  